import Api from './Api'

export default {
    get(keyword, pageNumber, pageSize, order) {
        return Api().get(`document?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getOne(id) {
        return Api().get(`document/${id}`);
    },
    create(data) {
        return Api().post(`document`, data);
    },
    update(data) {
        return Api().put(`document/${data.id}`, data);
    }
}